export interface DialCode {
  code: string;
  dialCode: string;
}

export const DIAL_CODES: DialCode[] = [
  { code: "PL", dialCode: "+48" },
  { code: "AT", dialCode: "+43" },
  { code: "BE", dialCode: "+32" },
  { code: "BG", dialCode: "+359" },
  { code: "BA", dialCode: "+387" },
  { code: "HR", dialCode: "+385" },
  { code: "CY", dialCode: "+357" },
  { code: "CZ", dialCode: "+420" },
  { code: "DK", dialCode: "+45" },
  { code: "EE", dialCode: "+372" },
  { code: "FI", dialCode: "+358" },
  { code: "FR", dialCode: "+33" },
  { code: "DE", dialCode: "+49" },
  { code: "GR", dialCode: "+30" },
  { code: "HU", dialCode: "+36" },
  { code: "IE", dialCode: "+353" },
  { code: "IT", dialCode: "+39" },
  { code: "LV", dialCode: "+371" },
  { code: "LT", dialCode: "+370" },
  { code: "LU", dialCode: "+352" },
  { code: "MT", dialCode: "+356" },
  { code: "NL", dialCode: "+31" },
  { code: "NO", dialCode: "+47" },
  { code: "PT", dialCode: "+351" },
  { code: "RO", dialCode: "+40" },
  { code: "RS", dialCode: "+381" },
  { code: "SK", dialCode: "+421" },
  { code: "SI", dialCode: "+386" },
  { code: "ES", dialCode: "+34" },
  { code: "SE", dialCode: "+46" },
  { code: "CH", dialCode: "+41" },
  { code: "UA", dialCode: "+380" },
  { code: "GB", dialCode: "+44" },
];
